var map = {
	"./dna.png": "3ad5",
	"./goggles.png": "6e07",
	"./microscope.png": "9289",
	"./noevilmonkey.png": "b2e0",
	"./offnik.png": "aeaf",
	"./paw.png": "cdcd",
	"./smile.png": "44c0",
	"./sparkles.png": "d148",
	"./tiger.png": "6478",
	"./trackball.png": "76da",
	"./victory.png": "be83",
	"./vulcan.png": "e247",
	"./winking-face.png": "ebd2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cac6";